import first from 'lodash/fp/first';
import flow from 'lodash/fp/flow';
import isUndefined from 'lodash/fp/isUndefined';
import map from 'lodash/fp/map';
import slice from 'lodash/fp/slice';
import { MAX_AUTO_SUGGEST_ITEMS, MAX_AUTO_SUGGEST_RADIUS } from '../../common/constants';
import type { RootDispatch } from '../../configuration/setup/store';
import { type ChargingStation, facadeApiV3 as facadeApi, QueryType } from '../../store/facade/facadeApiV3';
import { type SuggestionAddress, WaypointType } from '../../store/search/searchSlice';

const mapToAddress = (station: ChargingStation): SuggestionAddress => {
    return {
        title: station.name,
        position: { lat: station.location.latitude, lng: station.location.longitude },
        type: WaypointType.CHARGING_STATION,
        resultType: 'charging-station',
        station_id: station.id,
    };
};

const processStations = flow(slice(0, MAX_AUTO_SUGGEST_ITEMS), map(mapToAddress));

export const fetchChargingStationsNearAddresses =
    (processedAddresses: SuggestionAddress[]) => async (dispatch: RootDispatch) => {
        const center = first(processedAddresses)?.position;

        if (isUndefined(center)) {
            return [];
        }

        const { chargingStations } = await dispatch(
            facadeApi.endpoints.getChargingStationMetadataList.initiate({
                chargingStationMetadataRequest: {
                    queryType: QueryType.Nearest,
                    rangeFilter: {
                        center: {
                            latitude: center.lat,
                            longitude: center.lng,
                        },
                        radius: MAX_AUTO_SUGGEST_RADIUS,
                    },
                    pageSize: MAX_AUTO_SUGGEST_ITEMS,
                },
            })
        ).unwrap();

        return processStations(chargingStations);
    };
